import React, { useState } from "react";
import { addDomainToCart } from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { notifyWarning, notifySuccess } from "components/ToastMessage";
import { Card, Form } from 'react-bootstrap';

const ExistingDomain = (props) => {
  const { domainMethod, setDomainMethod } = props;
  const dispatch = useDispatch();
  const [domain, setDomain] = useState("");
  const { productsList: cartItems } = useSelector((state) => state.cart);

  const additionalValidTlds = [".desa.id", ".go.id", ".mil.id", ".net.id"];

  const options = (props.extOption || []).map((option) => ({
    value: option[1],
    label: option[1],
    price: option[4],
  }));

  const handleClick = () => {
    if (domain) {
      // Bersihkan domain input
      const cleanDomain = domain.trim().toLowerCase();
      
      if (!cleanDomain.includes(".")) {
        notifyWarning("Domain tidak valid!");
        return;
      }

      const kamus = [
        "togel",
        "judi",
        "sex",
        "porn",
        "bugil",
        "bokep",
        "xxx",
        "kontol",
        "casino",
        "kasino",
      ];

      const whitelist = [
        "camillajava",
        "javaleap",
        "unigoldtechnology",
        "livelifebetter",
        "sirajudinhasbi",
        "javapustaka",
        "lajudigital",
        "westjava-shizuoka",
        "betariko",
        "tipjavatransport",
      ];

      const badWord = kamus.some((str) => cleanDomain.includes(str));
      const whiteWord = whitelist.some((str) => cleanDomain.includes(str));
      const splitDomain = cleanDomain.split(".");
      const hasHostingOrResellerInCart = cartItems.find(
        (item) => item.type === "hostingaccount" || item.type === "reselleraccount"
      );

      // Validasi struktur domain
      if (splitDomain.length < 2) {
        notifyWarning("Domain tidak valid!");
        return;
      }

      // Domain name adalah array[0], extension adalah sisanya
      const domainName = splitDomain[0];
      const extension = splitDomain.slice(1).join(".");

      // Validasi nama domain
      if (!domainName || domainName === "") {
        notifyWarning("Nama domain tidak boleh kosong!");
        return;
      }

      if (domainName.length < 2) {
        notifyWarning("Nama domain minimal 2 karakter!");
        return;
      }

      // Validasi extension
      if (!extension || extension === "") {
        notifyWarning("Ekstensi domain tidak boleh kosong!");
        return;
      }

      // Cek jika ada lebih dari 2 bagian (seperti subdomain.domain.com)
      if (splitDomain.length > 2) {
        // Untuk domain dengan multiple dots seperti .co.id, .desa.id, dll
        const tldString = "." + extension;
        const validTlds = [
          ...options.map((option) => option.value),
          ...additionalValidTlds,
        ];
        
        // Jika bukan TLD yang valid, anggap sebagai subdomain
        if (!validTlds.includes(tldString) && !additionalValidTlds.some(tld => tldString.endsWith(tld))) {
          notifyWarning("Penggunaan subdomain tidak diperbolehkan!");
          return;
        }
      }

      // Validasi karakter tidak valid
      if (/[<> !@#$%^&*()_+=;:?/\\|}{\][~`]/.test(cleanDomain)) {
        notifyWarning("Domain mengandung karakter tidak valid!");
        return;
      }

      // Validasi kata terlarang
      if (badWord && !whiteWord) {
        notifyWarning("Domain Anda mengandung kata terlarang!");
        return;
      }

      // Validasi hosting di cart
      if (!hasHostingOrResellerInCart) {
        notifyWarning("Tidak ada paket hosting di dalam keranjang!");
        return;
      }

      dispatch(addDomainToCart({ domain: cleanDomain, type: "domain-existing" }));
      notifySuccess(`${cleanDomain} Berhasil ditambahkan!`);
    }
  };

  const handleMethodChange = () => {
    setDomainMethod("existing");
  };

  return (
    <Card className="rounded-4 border-0 shadow-sm mb-4">
      <Card.Body>
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold text-qw-primary mb-0">
                Domain Existing
              </h5>
            </div>
            
            <div className="form-check py-3 px-4 mb-3" style={{ 
              border: '2px solid #e0e6ed',
              borderRadius: '8px',
              backgroundColor: domainMethod === "existing" ? '#f8f9fa' : 'transparent'
            }}>
              <div className="d-flex align-items-start ps-2">
                <input
                  type="radio"
                  className="form-check-input me-3"
                  name="domainMethod"
                  id="existingDomain"
                  value="existing"
                  checked={domainMethod === "existing"}
                  onChange={handleMethodChange}
                  style={{ marginTop: '2px' }}
                />
                <div className="flex-grow-1">
                  <label
                    htmlFor="existingDomain"
                    className="form-check-label fw-bold d-block"
                  >
                    Gunakan domain yang sudah saya miliki
                  </label>
                  <p className="mb-0 mt-2 text-muted">
                    Domain Golden Fast Network sebelumnya bisa digunakan disini
                  </p>

                    {domainMethod === "existing" && (
                      <div className="mt-3">
                        <div className="row g-3">
                          <div className="col-12 col-md-9">
                            <Form.Control
                              type="text"
                              placeholder="Nama Domain Anda"
                              onChange={(e) => setDomain(e.target.value)}
                              value={domain}
                              style={{ 
                                border: '2px solid #e0e6ed',
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            />
                          </div>
                          <div className="col-12 col-md-3">
                            <button 
                              className="btn btn-cta w-100 rounded-5" 
                              onClick={handleClick}
                              style={{ 
                                borderRadius: '8px',
                                padding: '10px 16px'
                              }}
                            >
                              Gunakan
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ExistingDomain;